import { getRequest, putRequest } from '../../Services/HttpService';
import { TABLE_FUEL_CARD } from '../../Services/TableService';

const RESPONSE_OK = 'ok';

export const getFuelCardFormData = async () => {
  const response: Record<string, any> | false = await getRequest(`/v1/${TABLE_FUEL_CARD}/form`, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.data.form && response.status === 200) {
    return response.data.form.inputs;
  }
  return false;
};

export const getEditingData = async (id: number | string) => {
  const response: Record<string, any> | false = await getRequest(`/v1/vehicle/${id}`, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data.vehicle;
  }
  return false;
};

export const getValidation = async () => {
  const response: Record<string, any> | false = await getRequest(`/v1/vehicle/validation`, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const getFuelCardsOptions = async (customerId: string | null, vehicleId: number | null) => {
  const response = await getRequest<Record<string, any>>(
    `/v1/vehicle/form/fuelCards${customerId ? `?customerId=${customerId}` : ''}${
      vehicleId ? `&vehicleId=${vehicleId}` : ''
    }`,
    { returnAxiosResponse: true }
  );
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const getFuelCardsValues = async (vehicleId: number | null) => {
  const response = await getRequest<Record<string, any>>(
    `/v1/vehicle/form/fuelCardsAssigned${vehicleId ? `?vehicleId=${vehicleId}` : ''}`,
    { returnAxiosResponse: true }
  );
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const getVehicleTypeIdOptions = async () => {
  const response = await getRequest<Record<string, any>>(`/v1/vehicle/form/vehicleTypeList`, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const getDefaultDriverIdOptions = async (customerId: number | null) => {
  const url = `/v1/vehicle/form/defaultDriverList${customerId ? `?customerId=${customerId}` : ''}`;
  const response: Record<string, any> | false = await getRequest(url, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const getCostCenterIdOptions = async (vehicleId: string | number) => {
  const url = `/v1/vehicle/form/costCenterList?vehicleId=${vehicleId}`;
  const response: Record<string, any> | false = await getRequest(url, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const getFuelTypeListOptions = async () => {
  const response: Record<string, any> | false = await getRequest(`/v1/vehicle/form/fuelTypeList`, {
    returnAxiosResponse: true,
  });
  if (response && response.data && response.status === 200) {
    return response.data;
  }
  return false;
};

export const editVehicle = async (values, id) => {
  const response: Record<string, any> | false = await putRequest(`/v1/vehicle/${id}/edit`, values);
  return !!(response && response.status === RESPONSE_OK);
};
